// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"color_default": "#ae9a69",
	"color_default_block": "#b4a172",
	"color_default_light": "#f6f4f0",
	"color_dark": "#1e1e1e",
	"color_dark2": "#000000",
	"color_grey4": "#fbfbfd",
	"color_grey3": "#999999",
	"color_grey2": "#e1e1e1",
	"color_grey1": "#f4f4f4",
	"color_lightBg": "#F7F8FB",
	"color_white": "#FFFFFF",
	"color_uired": "#b41d23",
	"color_uigreen": "#2bb578",
	"color_fb": "#3c599b",
	"color_qq": "#68a5e1",
	"color_vx": "#4ba44c",
	"color_wb": "#ff9933"
};
module.exports = exports;
